module.exports = __webpack_public_path__ + "static/media/logo.dc5d1498.png";